"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNearestValidRangeBottom = void 0;
const getNearestValidRangeBottom = (rangeBottom, newRowsPerPage) => {
  let newRangeBottom = rangeBottom;
  if ((rangeBottom - 1) % rangeBottom !== 0) {
    newRangeBottom = Math.floor(rangeBottom / newRowsPerPage) * newRowsPerPage + 1;
  }
  return newRangeBottom;
};
exports.getNearestValidRangeBottom = getNearestValidRangeBottom;
//# sourceMappingURL=helpers.js.map